import React from 'react';

const services = [
    { title: 'SuNaada', img: '/img/NS.png' }, // Sparrow
    { title: 'NaadaNatya', img: '/img/PeacockShield.png' }, // Peacock
    { title: 'BhaavaNaada', img: '/img/ParrotShield.png' }, // Parrot
];

export default function Services() {
    return (
        <section className="services pb-5">
            <div className="container text-center">
                <div className="row justify-content-center">
                    {services.map((s, i) => (
                        <div key={i} className="col-md-4 col-sm-6 mb-4">
                            <h3 className="service-title">{s.title}</h3>
                            <div className="service-circle ">
                                <img src={s.img} alt={s.title} className="img-fluid" />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}